import React from "react";

interface IngresoLoadingProps {
  data: any;
  progress: number;
  handleHideIngreso: any;
  isIngresoHidden: any;
}
declare const window: any;

const IngresoLoadingMobile = ({
  data,
  progress,
  handleHideIngreso,
  isIngresoHidden,
}: IngresoLoadingProps) => {
  return (
    <div className="ingreso-container-mobile">
      {data?.logos_multiples !== undefined &&
      data?.logos_multiples?.length > 0 ? (
        <div className="ingreso-logo-constructora-builder-mobile">
          <img
            src={
              (window.hybrid
                ? ""
                : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
              data.logo_constructora
            }
            alt=""
          ></img>
          {data?.logos_multiples?.map((logo: any) => (
            <img
              src={
                (window.hybrid
                  ? ""
                  : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                logo.link
              }
              alt=""
            ></img>
          ))}
        </div>
      ) : null}
      <div
        className="ingreso-logo-constructora-mobile"
        style={{ top: data?.logos_multiples !== undefined && data?.logos_multiples?.length > 0 ? "7%" : "5%" }}
      >
        {data?.logos_multiples !== undefined &&
        data.logos_multiples.length === 0 ? (
          <img
            src={
              (window.hybrid
                ? ""
                : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
              data.logo_constructora
            }
            alt=""
          ></img>
        ) : null}
        <img
          src={
            (window.hybrid
              ? ""
              : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
            data.logo_proyecto
          }
          alt=""
          style={{ maxWidth: data?.logos_multiples !== undefined && data?.logos_multiples?.length > 0 ? "7rem" : "6rem" }}
        ></img>
      </div>
      <div
        className="nota-legal-container-mobile"
        style={{ color: data.colors ? data.colors.main_text : "" }}
      >
        {data.texto_legal}
      </div>
      {
        <div
          className={
            progress < 95
              ? "loading-container-mobile fade-in"
              : "loading-container-mobile fade-out"
          }
        >
          <div
            className="loading-progress-mobile"
            style={{
              width: progress + "%",
              backgroundColor: data.colors ? data.colors.main_buttons : "",
            }}
          />
        </div>
      }
      {
        <div
          className={
            progress < 95
              ? "loading-progress-number-mobile fade-in"
              : "loading-progress-number-mobile fade-out"
          }
        >
          {progress}%
        </div>
      }
      {!isIngresoHidden ? (
        <div
          className={
            progress >= 95
              ? "enter-btn-mobile fade-in"
              : "enter-btn-mobile fade-out"
          }
          style={{
            backgroundColor: data.colors ? data.colors.main_buttons : "",
            color: data.colors ? data.colors.secondary_text : "",
          }}
          onClick={() => {
            handleHideIngreso();
          }}
          data-type={"INGRESO"}
          data-value={"INGRESO"}
        >
          Aceptar y continuar
        </div>
      ) : null}
      <div className="powered-by-mobile">
        Powered by ® Umbra 3D Studio - {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default IngresoLoadingMobile;
